import { render, staticRenderFns } from "./MyAllStudent.vue?vue&type=template&id=66dc911f&scoped=true&"
import script from "./MyAllStudent.vue?vue&type=script&lang=js&"
export * from "./MyAllStudent.vue?vue&type=script&lang=js&"
import style0 from "./MyAllStudent.vue?vue&type=style&index=0&id=66dc911f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dc911f",
  null
  
)

export default component.exports